import React from 'react';

import AssignmentsFoldersDropdown from '../AssignmentsFoldersDropdown.react';
import {Icon, NavItem} from '@albert-io/atomic';
import {Link} from 'react-router';
import useNavItems from '../useNavItems';

const MainNavItems = () => {
  const {pathname} = window.location;
  const {getIsMatchingRoute, mainNavItems} = useNavItems();

  return (
    <nav className='global-nav__main' aria-label='main'>
      <ul className='global-nav__main-list'>
        {mainNavItems.map((navItem) => {
          const {hardLink = false, icon, key, name, route} = navItem;

          const isMatchingRoute = getIsMatchingRoute(navItem);
          const props = {
            [hardLink ? 'href' : 'to']: route
          };
          const LinkElement = hardLink ? 'a' : Link;

          if (key === 'assignments') {
            return (
              // @ts-ignore
              <AssignmentsFoldersDropdown
                key={key}
                isMatchingRoute={isMatchingRoute}
                navItem={navItem}
                pathname={pathname}
                {...props}
              />
            );
          }

          return (
            <li key={key}>
              {/* @ts-ignore */}
              <NavItem {...props} as={LinkElement} active={isMatchingRoute} className='flex gap-x1'>
                {icon !== undefined && <Icon icon={icon} />}
                {name}
              </NavItem>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MainNavItems;
